import React from "react";
import PropTypes from "prop-types";
import { ConfirmationModalStyled } from "./ConfirmationModal.styled";
import { PrimaryButton, SecondaryButton } from "../components";

/**
 * Reusable Confirmation Modal
 * Used for cancel operations across Smart Plans, Direct Debit and Payment Links
 */
export const ConfirmationModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title,
  message,
  confirmLabel,
  cancelLabel,
  isLoading,
  primaryButtonBgColor, 
}) => {
  return (
    <ConfirmationModalStyled
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
    >
      <div className="modal-body">
        <div className="icon-container">
          <div className="info-icon">i</div>
        </div>
        <div className="text-container">
          <h2 className="modal-title">{title}</h2>
          <p className="modal-message">{message}</p>
        </div>
        <div className="actions-container">
          <SecondaryButton
            label={cancelLabel}
            onClick={onHide}
            disabled={isLoading}
          />
          <PrimaryButton
            label={isLoading ? "Processing..." : confirmLabel}
            onClick={onConfirm}
            disabled={isLoading}
            isLoading={isLoading}
            noBorder={true}
            centerAlign={true}
            bgColor={primaryButtonBgColor ? primaryButtonBgColor : null}
          />
        </div>
      </div>
    </ConfirmationModalStyled>
  );
};

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  primaryButtonBgColor: PropTypes.string,
};

ConfirmationModal.defaultProps = {
  isLoading: false,
  primaryButtonBgColor: null,
};